import { ProductTypeEnum, type PersistedDefaultTabProps } from '@talos/kyoko';
import type { PriceBlotterColumn, PriceBlotterFilter, PriceBlotterTabProps } from './types';

export const DEFAULT_PRICE_BLOTTER_COLUMNS: PriceBlotterColumn[] = ['Symbol', 'SecurityMarketData-Symbol', 'expandRow'];
export const DEFAULT_PRICE_BLOTTER_FILTER: PriceBlotterFilter = {};

export const DEFAULT_MULTILEG_PRICE_BLOTTER_COLUMNS: PriceBlotterColumn[] = [
  'Symbol',
  'SecurityMarketData-Leg1',
  'SecurityMarketData-Symbol',
  'SecurityMarketData-Leg2',
  'expandRow',
];
export const DEFAULT_MULTILEG_PRICE_BLOTTER_FILTER: PriceBlotterFilter = {
  ProductTypes: [ProductTypeEnum.Synthetic, ProductTypeEnum.Basis, ProductTypeEnum.CFD, ProductTypeEnum.CalendarSpread],
};

export const DEFAULT_PRICE_BLOTTER_TAB: PersistedDefaultTabProps<PriceBlotterTabProps> = {
  label: 'Price Grid',
  id: 'default-price-grid-tab',
  defaultColumns: DEFAULT_PRICE_BLOTTER_COLUMNS,
  defaultFilter: DEFAULT_PRICE_BLOTTER_FILTER,
};

export const PRICE_BLOTTER_PREFIX = 'price-blotter';
export const PRICE_BLOTTER_PORTAL_ID = 'price-blotter-portal';
